import insightsPlugin from './insights';

// eslint-disable-next-line import/prefer-default-export
export const insights = insightsPlugin;



// WEBPACK FOOTER //
// ./src/store/middlewares/index.js